import { IStateRecharge } from 'src/entity/StateEntity';
import { RECHARGE_SUCCESS } from 'src/constants/ActionTypes';

const initialState: IStateRecharge = {
  type: RECHARGE_SUCCESS,
  options: [],
};

export const rechargeState = (state: IStateRecharge = initialState, action: IStateRecharge): IStateRecharge => {
  switch (action.type) {
    case RECHARGE_SUCCESS:
      return Object.assign({}, state, {
        type: action.type,
        options: action.options,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/rechargeState.ts